import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
} from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { ApiError } from './api.service';
import { AccessRouterService } from '../libs/components/access-router-outlet/access-router.service';
import { AlertService } from './alert.service';

// https://stackoverflow.com/a/72816957
export const IGNORED_STATUSES = new HttpContextToken<number[]>(() => []);

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService, private access: AccessRouterService, private alerts: AlertService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const ignoredStatuses = request.context.get(IGNORED_STATUSES);

    return next.handle(request).pipe(
      catchError(async err => {
        if ([401].includes(err.status) && !ignoredStatuses?.includes(err.status)) {
          await this.auth.logout();
          throw err;
        }
        if ([403].includes(err.status) && !ignoredStatuses?.includes(err.status)) {
          // if (request.method === 'GET') {
            // this.access.setForbidden();
            this.alerts.info('warnings.forbidden');
          // }
        }
        throw err; // TODO: Identificar els errors de la API propia
        throw new ApiError(err);
      })
    );
  }
}
